import React, { useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";
import IcLixo from "../../../components/Svg/IcLixo";
import Checkbox from "../../../components/Checkbox";
import Slct from "../../../components/Slct";
import Accordion from "../../../components/Accordion";
import TableResponsive from "../../../components/TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";
import Button from "../../../components/Button";
import SwitchCheckbox from "../../../components/SwitchCheckBox";
import printRules from "../../../components/PrintRules/style.module.scss";
import { Currency, IntegerNumber, InputText } from "../../../components/Input";
import SpoilerLink from "../../../components/SpoilerLink";
import style from "./style.module.css";
import Results from "../../../components/Results";
import styleAccordeon from "../../../components/Accordeon/style.module.css";

// Pure row-descriptor builder for a single resource -- kept outside the component so it doesn't get
// recreated on every render, and so its shape/behavior is easy to diff against the original inline code.
function buildResourceRow({ resource, resourceIndex, eventIndex, resourceOptions, onUpdateResource, onRemoveResource, formatReal }) {
  return {
    key: `resource-${resource.id ?? `new-${resourceIndex}`}`,
    show_spoiler: !!resource?.description,
    data: [
      {
        className: printRules.hide_on_print,
        element: (
          <Checkbox
            checked={resource?.show}
            onChange={__ev => {
              onUpdateResource({
                event_i: eventIndex,
                resource_i: resourceIndex,
                key: "show",
                value: __ev.target.checked,
              });
            }}
          />
        ),
      },
      {
        element: (
          <>
            <Slct
              required={true}
              placeholder="..."
              value={resource?.resource_id}
              onChange={__ev => {
                onUpdateResource({
                  event_i: eventIndex,
                  resource_i: resourceIndex,
                  key: "resource_id",
                  value: __ev.value,
                });
              }}
              options={resourceOptions || []}
              className={printRules.hide_on_print}
            />
            <p className={printRules.hide_not_print}>{resource?.name || "-"}</p>
          </>
        ),
      },
      {
        element: (
          <>
            <Slct
              placeholder="..."
              value={resource?.provider_id}
              onChange={__ev => {
                onUpdateResource({
                  event_i: eventIndex,
                  resource_i: resourceIndex,
                  key: "provider_id",
                  value: __ev.value,
                });
              }}
              options={resourceOptions?.find(__r_f => __r_f?.value === resource?.resource_id)?.avaible_supliers || []}
              className={printRules.hide_on_print}
            />
            <p className={printRules.hide_not_print}>{resource?.provider_name || "-"}</p>
          </>
        ),
      },
      {
        element: (
          <IntegerNumber
            value={resource?.qtd}
            valueChange={__ev => {
              onUpdateResource({
                event_i: eventIndex,
                resource_i: resourceIndex,
                key: "qtd",
                value: parseInt(__ev) || null,
              });
            }}
            maxlength="10"
            placeholder="0"
          />
        ),
      },
      {
        element: (
          <Currency
            value={resource?.single_value}
            valueChange={__ev => {
              onUpdateResource({
                event_i: eventIndex,
                resource_i: resourceIndex,
                key: "single_value",
                value: __ev || null,
              });
            }}
          />
        ),
      },
      {
        element: (
          <span className="text-nowrap">{formatReal((resource?.single_value || 0) * (resource?.qtd || 0))}</span>
        ),
      },
      {
        element: <SpoilerLink text="" bold={!!resource?.description} />,
        className: printRules.hide_on_print,
        id: `description-${eventIndex}-${resourceIndex}`,
        spoiler: (
          <>
            <InputText
              placeholder="Descrição"
              value={resource?.description}
              onChange={__ev => {
                onUpdateResource({
                  event_i: eventIndex,
                  resource_i: resourceIndex,
                  key: "description",
                  value: __ev.target.value || "",
                });
              }}
              className={printRules.hide_on_print}
            />
            <p className={printRules.hide_not_print}>{resource?.description || ""}</p>
          </>
        ),
      },
      {
        className: printRules.hide_on_print,
        element: (
          <button
            type="button"
            className="simple-ico"
            onClick={() => {
              onRemoveResource({
                event_i: eventIndex,
                resource_i: resourceIndex,
              });
            }}
          >
            <IcLixo />
          </button>
        ),
      },
    ],
  };
}

function EventAccordionItem(props) {
  const {
    event,
    eventIndex,
    resourceOptions,
    totalTrainees,
    commercial,
    eventTrainees,
    onUpdateResource,
    onRemoveResource,
    onAddResource,
    onUpdateInvite,
  } = props;

  const { formatReal } = useFormat();

  const [showTrainees, setshowTrainees] = useState(false);

  const resourcesTotal = useMemo(
    () =>
      event?.resources?.reduce((__acc, __resource) => __acc + (__resource?.single_value * __resource?.qtd || 0), 0) ||
      0,
    [event.resources],
  );

  // Base (qtd por formando × valor unitário × formandos esperados) — já embutida no total do
  // evento/pacote, igual a qualquer outro recurso. Negociações individuais (extras) são tratadas
  // à parte, no financeiro específico do formando.
  const invitesTotal = useMemo(
    () =>
      (event.qtd_invitations || 0) * (event.value_invitation || 0) * totalTrainees +
      (event.qtd_tickets || 0) * (event.value_ticket || 0) * totalTrainees,
    [event.qtd_invitations, event.qtd_tickets, event.value_invitation, event.value_ticket, totalTrainees],
  );

  const eventTotal = resourcesTotal + invitesTotal;

  const resourceRows = useMemo(
    () =>
      event.resources.map((__resource, __resource_i) =>
        buildResourceRow({
          resource: __resource,
          resourceIndex: __resource_i,
          eventIndex,
          resourceOptions,
          onUpdateResource,
          onRemoveResource,
          formatReal,
        }),
      ) || [],
    [event.resources, eventIndex, resourceOptions, onUpdateResource, onRemoveResource, formatReal],
  );

  return (
    <>
      {(event.name !== "Sem Eventos" ||
        commercial?.custom_payments?.filter(__payment => __payment.event_id === event.id).length > 0) && (
        <>
          {(event.id !== null || !!commercial?.is_class) && (
            <Accordion.Item
              eventKey={`${eventIndex + 1}`}
              className={`${eventIndex > 0 ? "-print-avoid-break" : ""}`}
              data-new-component={true}
              data-has-error={event?.resources?.some(__resource => !__resource?.resource_id)}
            >
              <Accordion.Header eventKey={`${eventIndex + 1}`} className={styleAccordeon.toggle}>
                <p className={styleAccordeon.title} data-title="true">
                  {event.name}
                  {event.id !== null && (
                    <p className="small-label mb-0">
                      {" "}
                      <b>{totalTrainees}</b> Formandos Esperados
                    </p>
                  )}
                </p>
                <Accordion.Extras>
                  {event.id !== null ? (
                    <>
                      <p className="m-0">{formatReal(eventTotal)}</p>
                      {event.number_trainees.total > 0 && (
                        <p className="ml-2 mb-0">
                          {formatReal(eventTotal / totalTrainees)} / formando
                        </p>
                      )}
                    </>
                  ) : (
                    <p className="m-0">
                      {formatReal(
                        commercial?.custom_payments
                          ?.filter(__payment => __payment.event_id === null)
                          ?.reduce((p2, e2) => p2 + e2.value_total, 0),
                      )}
                    </p>
                  )}
                </Accordion.Extras>
              </Accordion.Header>
              <Accordion.Body>
                {event.id !== null && (
                  <>
                    <p className="small-label mb-2">
                      <b>Base de Convites e Ingressos por Formando</b> neste evento — já está inclusa no total acima e
                      no financeiro do formando (rateada igual entre todos, junto com os recursos). Negociações
                      individuais que fugirem dessa base são tratadas à parte, na renegociação de cada formando. A
                      listagem abaixo mostra o que cada um tem negociado, só pra controle.
                    </p>
                    <TableResponsive
                      table={{
                        head: [
                          { data: "Base de Convites por Formando" },
                          { data: "Valor Unitário (Convite)" },
                          { data: "Base de Ingressos por Formando" },
                          { data: "Valor Unitário (Ingresso)" },
                        ],
                        body: [
                          {
                            data: [
                              {
                                element: (
                                  <IntegerNumber
                                    value={event.qtd_invitations}
                                    valueChange={__ev => {
                                      onUpdateInvite({
                                        event_i: eventIndex,
                                        key: "qtd_invitations",
                                        value: parseInt(__ev) || null,
                                      });
                                    }}
                                    placeholder="0"
                                  />
                                ),
                              },
                              {
                                element: (
                                  <Currency
                                    value={event.value_invitation}
                                    valueChange={__ev => {
                                      onUpdateInvite({
                                        event_i: eventIndex,
                                        key: "value_invitation",
                                        value: __ev || null,
                                      });
                                    }}
                                  />
                                ),
                              },
                              {
                                element: (
                                  <IntegerNumber
                                    value={event.qtd_tickets}
                                    valueChange={__ev => {
                                      onUpdateInvite({
                                        event_i: eventIndex,
                                        key: "qtd_tickets",
                                        value: parseInt(__ev) || null,
                                      });
                                    }}
                                    placeholder="0"
                                  />
                                ),
                              },
                              {
                                element: (
                                  <Currency
                                    value={event.value_ticket}
                                    valueChange={__ev => {
                                      onUpdateInvite({
                                        event_i: eventIndex,
                                        key: "value_ticket",
                                        value: __ev || null,
                                      });
                                    }}
                                  />
                                ),
                              },
                            ],
                          },
                        ],
                      }}
                    />
                    <p className={`mt-2 ${printRules.hide_on_print}`}>
                      <SwitchCheckbox
                        label="Mostrar Formandos"
                        checked={!!showTrainees}
                        onChange={__ev => setshowTrainees(__ev.target.checked)}
                      />
                    </p>
                    {!!showTrainees && (
                      <TableResponsive
                        emptyMsg="Nenhum formando neste evento."
                        className={printRules.hide_on_print}
                        table={{
                          head: [
                            { data: "Nome" },
                            { data: "Convites Contratados" },
                            { data: "Ingressos Contratados" },
                          ],
                          body:
                            eventTrainees?.map(__trainee => ({
                              data: [
                                { element: <span>{__trainee.name}</span> },
                                {
                                  element: <span>{__trainee.qtd_invitations ?? "-"}</span>,
                                },
                                {
                                  element: <span>{__trainee.qtd_tickets ?? "-"}</span>,
                                },
                              ],
                            })) || [],
                        }}
                      />
                    )}
                    <div className="divisor mt-3 mb-3"></div>
                    <TableResponsive
                      emptyMsg="Nenhum recurso cadastrado neste evento."
                      table={{
                        head: [
                          { data: "Exibir", className: printRules.hide_on_print },
                          { data: "Recurso", className: style.resource },
                          { data: "Fornecedor", className: style.provider },
                          { data: "Quantidade", className: style.qtd },
                          { data: "Valor Unit.", className: style.value },
                          { data: "Total" },
                          { data: "Espec.", className: printRules.hide_on_print },
                          { data: "", className: printRules.hide_on_print },
                        ],
                        body: resourceRows,
                      }}
                    />
                    <div>
                      <Button
                        size="sm"
                        className={printRules.hide_on_print}
                        onClick={() => {
                          onAddResource({
                            event_i: eventIndex,
                            category_id: event.category_id,
                            event_id: event.id,
                          });
                        }}
                      >
                        Adicionar Recurso
                      </Button>
                    </div>
                  </>
                )}

                {commercial?.custom_payments?.filter(__payment => __payment.event_id === event.id).length > 0 && (
                  <>
                    {event.id !== null && <div className="divisor mt-4 mb-3"></div>}
                    <h2 className={`mini-title mb-2 ${event.id !== null ? "mt-3" : ""}`}>
                      Itens Adicionais <span className="small-label">(Individuais)</span>
                    </h2>
                    <TableResponsive
                      table={{
                        head: [
                          { data: "Item" },
                          { data: "Aquisição" },
                          { data: "Formando" },
                          { data: "Valor Unitário" },
                          { data: "Quantidade" },
                          { data: "Taxa" },
                          { data: "Total" },
                        ],
                        body:
                          commercial?.custom_payments
                            ?.filter(__payment => __payment.event_id === event.id)
                            .map(__payment => ({
                              data: [
                                {
                                  element: <span style={{ whiteSpace: "nowrap" }}>{__payment.name}</span>,
                                },
                                {
                                  element: <span style={{ whiteSpace: "nowrap" }}>{__payment.payer_type_label}</span>,
                                },
                                {
                                  element: <span style={{ whiteSpace: "nowrap" }}>{__payment.trainees?.name}</span>,
                                },
                                {
                                  element: (
                                    <span style={{ whiteSpace: "nowrap" }}>{formatReal(__payment.value || 0)}</span>
                                  ),
                                },
                                {
                                  element: <span style={{ whiteSpace: "nowrap" }}>{__payment.quantity || 0}</span>,
                                },
                                {
                                  element: (
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      {formatReal(__payment.convenience_fee || 0)}
                                    </span>
                                  ),
                                },
                                {
                                  element: (
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      {formatReal(
                                        (__payment.value || 0) * (__payment.quantity || 0) +
                                          __payment.convenience_fee,
                                      )}
                                    </span>
                                  ),
                                },
                              ],
                            })) || [],
                      }}
                    />
                    <Row>
                      <Col sm={{ span: 4, offset: 8 }}>
                        <Results
                          rows={[
                            {
                              label: (
                                <>
                                  Total <span className="small-label">(Itens Adicionais)</span>
                                </>
                              ),
                              value: formatReal(
                                commercial?.custom_payments
                                  ?.filter(__payment => __payment.event_id === event.id)
                                  ?.reduce(
                                    (__acc, __payment) =>
                                      __acc +
                                      ((__payment.value || 0) * (__payment.quantity || 0) + __payment.convenience_fee ||
                                        0),
                                    0,
                                  ) || 0,
                              ),
                              type: "dark",
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Accordion.Body>
            </Accordion.Item>
          )}
        </>
      )}
    </>
  );
}

export default React.memo(EventAccordionItem);
